import { React, lazy, Fragment, useSelector, velorantPoster, foodPoster, groceryPoster, advanturePoster, christmasProductDetailBG2 } from "../../imports/generalImport";
import { Grid, Container, useMediaQuery, Box } from "../../imports/muiImport";
import { Helmet } from 'react-helmet-async';

// Components Imports
import Poster from '../../components/poster/Poster';
import CompanyPortfolio from "../ABOUTUS/CompanyPortfolio";
import GiftCardSkeleton from "./GiftCardSkeleton";
import HeroSlider from "../../components/homeSlider";
import ProductCategory from "../../components/category/ProductCategory";

const MobileAppSection = lazy(() => import("../../components/appStore"));
const GiftsSection = lazy(() => import("../../components/sections/GiftsSection"));
const ThreeGiftCard = lazy(() => import("./ThreeGiftCard"));
const GiftCardWorking = lazy(() => import("./GiftCardWorking"));
const OurCustomer = lazy(() => import("../../components/ourClients"));
const HomePageTextDetails = lazy(() => import("../../components/textContent/giftBuyGuide"));
const Testimonial = lazy(() => import("../../components/testimonial"));

const Homepage = () => {
    const lgDevices = useMediaQuery("(min-width:1200px)");
    const BestSellerProducts = useSelector((state) => state.BestSeller.allData);
    const FeatureProducts = useSelector((state) => state.FeaturedProducts.allData);
    const TopFiveProducts = useSelector((state) => state.TopFiveProducts.allData);
    const EntertainmentProducts = useSelector((state) => state.EntertainmentProducts.allData);
    const canonicalUrl = `https://www.99gift.in`;

    return (
        <Fragment>
            <Helmet>
                <title>Gift Cards: Discounted eGift Cards for 250+ Brands in India</title>
                <meta name="description" content="99Gift offers a wide variety of discounted gift cards for over 250 brands in India, including Apparels, eCommerce, Entertainment, Travels, Food, Entertainment, Grocery, Mobile, Footwear Etc. You can also find E-Gift cards for personal and commercial use" />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:title" content="99Gift - 200+ Brands Discount Gift Vouchers Online" />
                <meta property="og:description" content="99Gift offers a wide variety of discounted gift cards for over 250 brands in India, including Apparels, eCommerce, Entertainment, Travels, Food, Entertainment, Grocery, Mobile, Footwear Etc. You can also find E-Gift cards for personal and commercial use" />
                <link rel="canonical" href={canonicalUrl} />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "http://schema.org",
                        "@type": "Organization",
                        "name": "99gift",
                        "description": "Welcome to 99gift.in, your ultimate destination for Gift Cards and Gift Vouchers in India! Whether you're looking to Buy Gift Cards Online or find the best Discount Gift Cards, we have you covered. Explore a wide variety of e-gift cards India and enjoy exciting gift card offers on top brands like Myntra, Nykaa, and more. Get your favorite gift card at a discount and shop Gift Cards with ease. At 99gift, we offer the best gift card deals and gift card discounts to make gifting simple and affordable. Buy discounted gift cards today and discover why 99gift is the top choice for Gift Card Online India!",
                        "url": "https://www.99gift.in/",
                        "sameAs": [
                            "https://www.facebook.com/99gift.in",
                            "https://www.linkedin.com/company/99-gift/",
                            "https://www.instagram.com/99gift.in/",
                            "https://www.99gift.in/blog",
                            "https://play.google.com/store/apps/details?id=in.nngift.vouchers&hl=en&gl=US",
                            "https://apps.apple.com/in/app/99gift/id1645057090",
                            "https://www.youtube.com/@99gift"
                        ],
                        "logo": "https://www.99gift.in/static/media/logo.1f56873eb49af1faa202.png",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "F-12 Agarsen Tower, Central Spine, Vidhyadhar Nagar",
                            "addressLocality": "Jaipur",
                            "addressRegion": "Rajasthan",
                            "postalCode": "302039",
                            "addressCountry": "IN"
                        },
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "contactType": "Customer Support",
                            "telephone": "+91-08742998998",
                            "email": "support@99gift.in"
                        },
                        "foundingDate": "2019",
                        "parentOrganization": "ZPAY SOLUTIONS PVT LTD",
                        "founder": {
                            "@type": "Person",
                            "name": "Jitesh Agarwal"
                        },
                        "location": {
                            "@type": "Place",
                            "name": "99gift",
                            "address": {
                                "@type": "PostalAddress",
                                "streetAddress": "F-12 Agarsen Tower, Central Spine, Vidhyadhar Nagar",
                                "addressLocality": "Jaipur",
                                "addressRegion": "Rajasthan",
                                "postalCode": "302039",
                                "addressCountry": "IN"
                            }
                        },
                        "areaServed": {
                            "@type": "Place",
                            "name": "India"
                        },
                        "knowsAbout": [
                            "Gift Cards",
                            "Gift Vouchers",
                            "Gift Card Online",
                            "eVouchers",
                            "Corporate Gift Cards",
                            "Digital Payments",
                            "Gaming Gift Cards",
                            "Shopping Vouchers",
                            "Personalized Gifting",
                            "E-gift cards"
                        ]
                    })}
                </script>
            </Helmet>

            <Container
                disableGutters
                maxWidth="false"
                sx={{
                    backgroundColor: 'white.main',
                 }}
            >
                <HeroSlider />
                <ProductCategory />

                <Container maxWidth="xl"
                    sx={{
                        mt: { sm: 8, lg: 2 },
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                    }}
                >
                    <Grid container maxWidth="false"
                        sx={{
                            my: 0,
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                        }}
                    >
                        {/* Featured Gift Vouchers */}
                        <Grid item xs={12} sx={{ mb: { sm: 8, lg: 6 } }}>
                            {!FeatureProducts.length ? (
                                <GiftCardSkeleton />
                            ) : (lgDevices ?
                                (<GiftsSection
                                    HeadingTitle="Featured Gift Vouchers"
                                    categoryTitle="Featured"
                                    showGift="false"
                                    giftCardData={FeatureProducts}
                                    mbackgroundColor="mbackground.main"
                                />)
                                :
                                (<ThreeGiftCard
                                    title="Featured Gift Vouchers"
                                    giftCardData={FeatureProducts}
                                    mbackgroundColor="white.main"
                                    design={{
                                        boxShadow: {
                                            sm: 0,
                                            md: 2,
                                            lg: "0px 8px 9px -5px rgb(98 45 81), 0px 15px 22px 2px rgb(86 70 94), 0px 6px 28px 5px rgba(0, 0, 0, 0.12);",
                                        },
                                        border: {
                                            sm: 9,
                                            lg: 0
                                        },
                                        borderColor: { sm: "borderColor.main2", lg: "borderColor.main2" },
                                    }}
                                    stylingClass="backgroundDesign"
                                    fixSlideView={lgDevices ? false : true}
                                />)
                            )}
                        </Grid>

                        {/* Best Seller Gift Cards */}
                        <Grid item xs={12} sx={{ mb: { sm: 8, lg: 6 } }}>
                            {!BestSellerProducts.length ? (
                                <GiftCardSkeleton />
                            ) : (lgDevices ?
                                (<GiftsSection
                                    HeadingTitle="Best Seller Gift Cards"
                                    showGift="false"
                                    categoryTitle="Best Seller Gift Cards"
                                    giftCardData={BestSellerProducts}
                                    cardNo={5}
                                    mbackgroundColor="mbackground.main"
                                />)
                                :
                                (<ThreeGiftCard
                                    title="Best Seller Gift Cards"
                                    giftCardData={BestSellerProducts}
                                    mbackgroundColor="white.main"
                                    design={{
                                        boxShadow: {
                                            sm: 0,
                                            md: 2,
                                            lg: "0px 8px 9px -5px rgb(98 45 81), 0px 15px 22px 2px rgb(86 70 94), 0px 6px 28px 5px rgba(0, 0, 0, 0.12);",
                                        },
                                        border: {
                                            sm: 9,
                                            lg: 0
                                        },
                                        borderColor: { sm: "borderColor.main2", lg: "borderColor.main2" },
                                    }}
                                    stylingClass="backgroundDesign"
                                    fixSlideView={lgDevices ? false : true}
                                />)
                            )}
                        </Grid>

                        {/* Best Gaming Gift Cards */}
                        <Grid item xs={12} sx={{ mb: { sm: 8, lg: 6 } }}
                            container
                            maxWidth="false"
                            justifyContent="stretch"

                        >
                            <Grid
                                item
                                lg={5}
                                xl={5}
                                sx={{
                                    display: {
                                        xs: "none",
                                        lg: "block"
                                    },
                                }}
                            >
                                <Poster
                                    path="/card-list?category=entertainment"
                                    image={advanturePoster}
                                    design={{
                                        boxShadow: "0px 8px 9px -5px rgb(32 31 32), 0px 15px 22px 2px rgb(102 107 107), 0px 6px 28px 5px rgba(0, 0, 0, 0.12)"
                                        // boxShadow: "0px 8px 9px -5px rgb(98 45 81), 0px 15px 22px 2px rgb(86 70 94), 0px 6px 28px 5px rgba(0, 0, 0, 0.12)"
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} lg={7}
                                sx={{
                                    pl: {
                                        xs: 0,
                                        lg: ".25rem"
                                    },
                                }}
                            >
                                <ThreeGiftCard
                                    title={lgDevices ? "Best Gaming Gift Cards" : "Best Entertainment Gift Cards"}
                                    giftCardData={EntertainmentProducts}
                                    mbackgroundColor="white.main"
                                    design={{
                                        boxShadow: {
                                            sm: 0,
                                            md: 2,
                                            // lg: "0px 8px 9px -5px rgb(98 45 81), 0px 15px 22px 2px rgb(86 70 94), 0px 6px 28px 5px rgba(0, 0, 0, 0.12);",
                                            lg: "0px 8px 9px -5px rgb(32 31 32), 0px 15px 22px 2px rgb(102 107 107), 0px 6px 28px 5px rgba(0, 0, 0, 0.12)"
                                        },
                                        border: {
                                            sm: 9,
                                            lg: 0
                                        },
                                        borderColor: { sm: "borderColor.main2", lg: "borderColor.main2" },
                                    }}
                                    stylingClass="backgroundDesign"
                                    fixSlideView={lgDevices ? false : true}
                                />
                            </Grid>
                        </Grid>

                        {/* Best Grocery Gift Cards */}
                        <Grid item xs={12} sx={{ mb: { sm: 8, lg: 6 } }}
                            container
                            maxWidth="false"
                            justifyContent="stretch"
                            flexDirection="row-reverse"
                        >
                            <Grid
                                item
                                lg={5}
                                xl={5}
                                sx={{
                                    display: {
                                        xs: "none",
                                        lg: "block"
                                    },
                                }}
                            >
                                <Poster
                                    path="/card-list?category=grocery-and-home-needs"
                                    image={groceryPoster}
                                    design={{
                                        boxShadow: "0px 8px 9px -5px rgb(42,79,44), 0px 15px 22px 2px rgb(42,79,44), 0px 6px 28px 5px rgba(0, 0, 0, 0.12)"
                                    }}
                                />
                            </Grid>


                            <Grid item xs={12} lg={7}
                                sx={{
                                    pr: {
                                        xs: 0,
                                        lg: ".25rem"
                                    },
                                }}
                            >
                                <ThreeGiftCard
                                    title="Best Grocery Gift Cards"
                                    giftCardData={TopFiveProducts?.[2]?.products}
                                    mbackgroundColor="white.main"
                                    stylingClass="grocerybackgroundDesign"
                                    design={{
                                        boxShadow: {
                                            sm: 0,
                                            md: 2,
                                            lg: "0px 8px 9px -5px #2a4f2c, 0px 15px 22px 2px #2a4f2c, 0px 6px 28px 5px rgba(0, 0, 0, 0.12);",
                                        },
                                        border: {
                                            sm: 9,
                                            lg: 0
                                        },
                                        borderColor: { sm: "borderColor.main2", lg: "borderColor.main2" },
                                    }}
                                    fixSlideView={lgDevices ? false : true}
                                />
                            </Grid>


                        </Grid>

                        {/* Best Food Gift Cards */}
                        <Grid item xs={12} sx={{ mb: { sm: 8, lg: 6 } }}
                            container
                            maxWidth="false"
                            justifyContent="stretch"
                        >
                            <Grid
                                item
                                lg={5}
                                xl={5}
                                sx={{
                                    display: {
                                        xs: "none",
                                        lg: "block"
                                    },
                                }}
                            >
                                <Poster
                                    path="/card-list?category=food"
                                    image={foodPoster}
                                    design={{
                                        boxShadow: "0px 8px 9px -5px rgb(255,134,136,100), 0px 15px 22px 2px rgb(255,134,136,100), 0px 6px 28px 5px rgba(0, 0, 0, 0.12)"
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} lg={7}
                                sx={{
                                    pl: {
                                        xs: 0,
                                        lg: ".25rem"
                                    },
                                }}
                            >
                                <ThreeGiftCard
                                    title="Best Food Gift Cards"
                                    giftCardData={TopFiveProducts?.[0]?.products}
                                    mbackgroundColor="white.main"
                                    stylingClass="foodbackgroundDesign"
                                    design={{
                                        boxShadow: {
                                            sm: 0,
                                            md: 2,
                                            lg: "0px 8px 9px -5px #ff8688, 0px 15px 22px 2px #ff8688, 0px 6px 28px 5px rgba(0, 0, 0, 0.12);",
                                        },
                                        border: {
                                            sm: 9,
                                            lg: 0
                                        },
                                        borderColor: { sm: "borderColor.main2", lg: "borderColor.main2" },
                                    }}
                                    fixSlideView={lgDevices ? false : true}

                                />
                            </Grid>

                        </Grid>

                    </Grid>
                </Container>

                <GiftCardWorking />
                <OurCustomer />
                <Container maxWidth="xl" disableGutters
                    sx={{
                        my: 0,
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                    }}>
                    <CompanyPortfolio />
                    <Testimonial />
                    <MobileAppSection />
                </Container>

                <Container maxWidth="xl" disableGutters
                    sx={{
                        my: 0,
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        backgroundColor: 'white.main',
                    }}>
                    <HomePageTextDetails />
                </Container>
            </Container>

        </Fragment>
    );
};

export default Homepage;

